// Generated by scripts/build_program_data.py — do not edit by hand.
//
// Demo video for each exercise, taken from the hyperlinks embedded in the
// source spreadsheets. Keys are normalised by `videoKey` in videos.ts.

export const EXERCISE_VIDEOS: Record<string, string> = {
  "1-arm lat pull-in": "https://youtu.be/RMGuHVQKOms?si=-jCa4oU2jhlxaqQ1",
  "ab wheel rollout": "https://youtu.be/gGTgyCU9gcg?si=8dvAAtP-P0KJcG_i",
  "arm circles": "https://youtu.be/tFpwBr_7KPg?si=2XC3Xw4zdmYLN-av&t=10",
  "arm swings": "https://youtu.be/tFpwBr_7KPg?si=mC4_uHgulB38cPTK",
  "arm-out single-arm db row": "https://youtu.be/1ydRu2K6oHg?si=VfJ5NSs8w4saTe3v",
  "arms-extended 45\u00b0 hyperextension": "https://youtu.be/PrwC-5NTCCs?si=TgycMfMHzfsT9QEh",
  "assisted pull-up": "https://youtu.be/iZQNHZuvfUQ?si=8ebn7wUmQ1vJwZRL",
  "barbell hip thrust": "https://youtu.be/8RwbLtfLu6A?si=WbzR0z0xfok9M1fp",
  "barbell jm press": "https://youtu.be/0F28Ha_9Y8Y?si=npJ8m73ZAwxTW4__",
  "barbell lunge": "https://youtu.be/Hr7Lp9cRvr4?si=4_Dt5ckF7fi8kbRi",
  "bayesian cable curl": "https://youtu.be/CWH5J_7kzjM?si=cMCtRVtRmwt39Qjf",
  "belt squat": "https://youtu.be/JvAc3k4Jdqw?si=QzPFigI900uAqkSi",
  "bench dip": "https://youtu.be/3CaIq8jZe18?si=eFll4q-9QKnxVs7W",
  "bent-over cable pec flye": "https://youtu.be/-7bVljkNWAs?si=k1rKZHUngkPpDhB0",
  "bent-over cable pec flye (w/ integrated partials)": "https://youtu.be/DKaKmnB0BO8?si=7WlS3gyYuhDl09Ib",
  "bent-over reverse db flye": "https://youtu.be/9BfxdGmekv4?si=ggOB5G9NPIRVN5tV",
  "bent-over reverse db flye (w/ integrated partials)": "https://youtu.be/eE3v36jNqDE?si=aKu2j9stF-xqFva1",
  "bicycle crunch": "https://youtu.be/OXs4DCS8Ei8?si=Tl-5kDYL3kVTytt_",
  "bodyweight dip": "https://youtu.be/iswhjR-_-Xg?si=X14sz9ue7jbcO41K",
  "bottom-2/3 constant tension preacher curl": "https://youtu.be/vHBedP8oeCA?si=vtauuKZkcSchNoqd",
  "bottom-2/3 ez-bar curl": "https://youtu.be/fXI8gN6pq1k?si=pmqyxsK7-i4cBqF9",
  "cable crunch": "https://youtu.be/epBrpaGHMcg?si=SydZopg-rqtxWUtt",
  "cable external rotation (optional)": "https://youtu.be/tFpwBr_7KPg?si=Rw3RDb-N8V4Dm5yI&t=39",
  "cable hip abduction": "https://youtu.be/552L1K3Rb_Q?si=6-OZxzNYiIcSs9KG",
  "cable hip adduction": "https://youtu.be/6GYTbv-LtV0?si=9ApT8Vb6y5rElWFE",
  "cable lat prayer": "https://youtu.be/YrcnBlH8XDA?si=cJ0tdsbirapsyDza",
  "cable paused shrug-in": "https://youtu.be/Hy6f1Lz_PiA?si=MTEbKv_uMCL6zvge",
  "cable reverse flye (mechanical dropset)": "https://youtu.be/nN5RV1arpfM?si=Bamq6i0Z8o10-Ihq",
  "cable shoulder press": "https://youtu.be/OfjncdW_Vyc?si=kiSMQzlVHKNIQJ7J",
  "cable skull crusher": "https://youtu.be/L3lMBRwsFlw?si=LQsBuPw2Dda3J5rU",
  "cable triceps kickback": "https://youtu.be/oRxTKRtP8RE?si=U2uRQ0vCvAR9Bkz5",
  "cable upright row": "https://youtu.be/Rm7CPzKLK1M?si=yAddmMzMaKojYhkt",
  "chest press machine (incline if upper pecs are lagging, flat if entire chest is lagging)": "https://youtu.be/zDecGJLyVm8?si=EwhnPqorXD5fsooV",
  "chest-supported machine row": "https://youtu.be/ijsSiWSzYw0?si=hClxWcLkjz1SkZUG",
  "chest-supported t-bar row": "https://youtu.be/q8qlHwcuOtc?si=J-TyFYuv9rwi5VTy",
  "chest-supported t-bar row + kelso shrug": "https://youtu.be/qsmjaYao9pA?si=16vkPtENX_eC3hoZ",
  "close-grip assisted dip": "https://youtu.be/mpcPTUAhfto?si=BPrSy06xtiOq-UPR",
  "close-grip bench press": "https://youtu.be/Yvz4fHuLfsw?si=Vw47-5iLI5m6zUqj",
  "close-grip push up": "https://youtu.be/z7Fx-RY4kXw?si=dzEM43Aki_I77F36",
  "concentration cable curl": "https://youtu.be/BFZyW_7ld0c?si=2quAznmV1D3pvYGG",
  "copenhagen hip adduction": "https://youtu.be/QRLGyl5-i4k?si=qeY5ksCS3V0996VG",
  "cross-body cable y-raise": "https://youtu.be/64RFJSCJuN8?si=wkooeub0BG4mRyUI",
  "cross-body lat pull-around": "https://youtu.be/8W67lZ5mwTU?si=o0tavum1mTCS9COi",
  "cuffed behind-the-back lateral raise": "https://youtu.be/fjiOCmFljDM?si=Q0xttHm6E4SfmD-E",
  "db bulgarian split squat": "https://youtu.be/Z1uu0uHYl20?si=PrV5_aQw_BtzIsCn",
  "db calf jumps": "https://youtu.be/JkY3nBTbRac?si=x-e5AhINv_RUBAxh",
  "db concentration curl": "https://youtu.be/Oq7gJuAuJh0?si=e07C_cAm11NoM2F5",
  "db flye": "https://youtu.be/HOg8Ftx5fUU?si=eLqEo6JgqeAMOjYf",
  "db flye (w/ integrated partials)": "https://youtu.be/AOsdioes78c?si=XT64ctRyclTbi31x",
  "db french press": "https://youtu.be/5KX0EjOTMaI?si=6jLt8_ysQTRK-i14",
  "db incline curl": "https://youtu.be/KSJc8bhSjB0?si=qJijMZGorCEXAOmk",
  "db lat pullover": "https://youtu.be/iaRefVKBH8M?si=1JkkgTxLJdJKru9F",
  "db lateral raise": "https://youtu.be/RyztKrzaMNk?si=d5M9ZaY77l9t4wnw",
  "db preacher curl": "https://youtu.be/WTkQLAethtg?si=WyxLoZFQzsaEYyn0",
  "db rdl": "https://youtu.be/TZAmthQJkh8?si=dvOpSndfzokVbz0S",
  "db rear delt swing": "https://youtu.be/1D4r_xpln88?si=7w7tNv71zmd29DUE",
  "db reverse lunge": "https://youtu.be/QSGe2Sd8kUI?si=ritsbewBHWwHZkBe",
  "db scott curl": "https://youtu.be/u00CqDeAHTE?si=HHavZlpk07IMBUzx",
  "db shrug": "https://youtu.be/moFqLlptX7Q?si=vsQXeROXKVa3beB7",
  "db skull crusher": "https://youtu.be/fbLTzgTKOR8?si=x0UOGZpmiuwP-Bip",
  "db step up": "https://youtu.be/3FNfi_PrP9Y?si=CUz9gH92JE2Wsx-o",
  "db step-up": "https://youtu.be/3FNfi_PrP9Y?si=xHZ-SXqhL_0_tXBD",
  "db triceps kickback": "https://youtu.be/YdUUYFgpA7g?si=xg98rhLezFMT8JSQ",
  "db walking lunge": "https://youtu.be/BC_eDtrB-M4?si=uodZc03RHxttla2G",
  "decline barbell press": "https://youtu.be/2Vg5j_UZr-U?si=PUEBgvJaIQxehtZl",
  "decline machine chest press": "https://youtu.be/AABuMGK9H28?si=zAYG2eDG9jFXGc6J",
  "decline smith machine press": "https://youtu.be/MlqHZEhBGtw?si=7QBH1RYZaEHJU5-E",
  "deficit pushup": "https://youtu.be/3AZSudcQ1N0?si=jQY4HpOBFC3xGrSZ",
  "donkey calf raise": "https://youtu.be/0eQQwveeQzw?si=qqLXhXn3xBGf6t2E",
  "dual-cable triceps press": "https://youtu.be/SNcQJjXWa_E?si=tGJUU1CwE1QkPqEZ",
  "dual-handle lat pulldown (mid-back + lats)": "https://youtu.be/NwQ5Ch5t5Vk?si=jvZGPLjh3kLwH4rb",
  "dumbbell chest press (incline if upper pecs are lagging, flat if entire chest is lagging)": "https://youtu.be/zGXvPjlgVkk?si=jdjm39AlZDL1G_Zo",
  "dumbbell lateral raise": "https://youtu.be/RyztKrzaMNk?si=iKwL0A4Uct72xC08",
  "elbows-in 1-arm db row": "https://youtu.be/SwloMZs8ZVk?si=4kRD4IFD34ht7fS2",
  "ez-bar skull crusher": "https://youtu.be/oDKGCsTjAk8?si=QzYsQK9BxcQj3pqW",
  "fat-grip db curl": "https://youtu.be/AE49-Oqh-0w?si=crNltzX7PLhFo1Dw",
  "fat-grip preacher curl": "https://youtu.be/Xx6iqyRM5Mk?si=GjRVl7xvbAaf9ciB",
  "floor skull crusher": "https://youtu.be/QZt9mms9o2E?si=d7Pj1t3H69XUuvw6",
  "front squat": "https://youtu.be/TRwhJ0TCoqI?si=wvQ3rpg_rnK2OlJ2",
  "front-to-back leg swings": "https://youtu.be/tFpwBr_7KPg?si=9Uxm-CNsEA7khMmd&t=19",
  "glute-ham raise": "https://youtu.be/9ksG-O0ZUto?si=I5F9HRiZe4C8JNOo",
  "goblet squat": "https://youtu.be/S2agsLlUSII?si=ZbM6zqY3sC151i0A",
  "good morning (light weight)": "https://youtu.be/c-Yj6God14s?si=X64i0QEQCFjrFDZM",
  "hack squat": "https://youtu.be/TWUnnDK8rck?si=NmqKbwgMcHmaDp6T",
  "half-kneeling 1-arm lat pulldown": "https://youtu.be/r8K1Fkch5go?si=uI9s4q0rLvAsHKtb",
  "half-kneeling pallof press": "https://youtu.be/iBbvHfbKiYc?si=L7nNy2PBZHoe2yxv",
  "hammer curl": "https://youtu.be/xY3sQXYhk7A?si=5lVqRX-mdG0goNnr",
  "hammer preacher curl": "https://youtu.be/dEdnC3ca-Yg?si=fAVE3jH_TAGmtG_u",
  "hanging leg raise": "https://youtu.be/rGqwkinWqYI?si=58o8OYWKc2-JwexT",
  "head harness neck extension": "https://youtu.be/Mp2kp2tVhGQ?si=_Tod6RiV9zHhwtJe",
  "helms row": "https://youtu.be/DjO2G9DIerQ?si=dfgV2iaTdED5w80S",
  "high-bar back squat": "https://youtu.be/V-B_Y-OvOTQ?si=T3Ib7zcVifxMEWtP",
  "incline chest-supported db row + kelso shrug": "https://youtu.be/IBRrEPQZUO0?si=MgGxKuB02bPXRy1q",
  "incline db stretch-curl": "https://youtu.be/Z0NIYS9nyoQ?si=dDGJmiudGbBIW7TT",
  "inverse db zottman curl": "https://youtu.be/jBIvbpyb99M?si=4tzkpKJGs95kLfBS",
  "katana triceps extension": "https://youtu.be/R7f45Mv7yyg?si=qHmldLEafD4llw6A",
  "kneeling overhead cable curl": "https://youtu.be/KokUK4RgsHc?si=yg2_1l_K1IZxCwYK",
  "lat pulldown": "https://youtu.be/IAktPXPhWYQ?si=GIbmS-vIl77yjMvg",
  "lat-focused cable row": "https://youtu.be/w11Kqjm-ycE?si=S2uUkOlSQS_XfJuz",
  "lateral band walk": "https://youtu.be/sOYvvFPYdsU?si=44gRXa_P6GNyjExC",
  "lean-back lat pulldown": "https://youtu.be/Zjzt4MRbAlc?si=Z5K9MxycnTyrnB1N",
  "lean-back machine pulldown": "https://youtu.be/CrfvmSGfT2c?si=hsWBdUyeIyjzr_7h",
  "leg extension": "https://youtu.be/uFbNtqP966A?si=4O6PTmmCpdLw3NAy",
  "leg press": "https://youtu.be/1yKAQLVV_XI?si=ySC3j7rHm8UrYN_O",
  "leg press calf jumps": "https://youtu.be/FKY1GmU-nYI?si=rzLyQiWauKQkJK5p",
  "leg press calf press": "https://youtu.be/S6DTPNZ_-F4?si=y3rx6TaVEuUONiI2",
  "llpt plank": "https://youtu.be/Q8ebdJL_-lo?si=KuWxih_GXUUZl4oq",
  "low incline barbell press": "https://youtu.be/_74oMsrIFXA?si=WJdYGe8B8Jbd68bB",
  "low incline db flye": "https://youtu.be/gfIx0U5bTMA?si=mJ5hulSBtwn-GgGk",
  "low incline db press": "https://youtu.be/YmlMsvNGTKA?si=uSFpSBJN7z3hkIeb",
  "low incline machine press": "https://youtu.be/JmsY9nSqX9E?si=ekdVWEiZOKpogCLF",
  "low incline smith machine press": "https://youtu.be/2ITgeRy2z2s?si=qtp6HdaKlsQiMuNS",
  "low-incline dumbbell flye": "https://youtu.be/gfIx0U5bTMA?si=ckWtAvqZaAS0gM5O",
  "low-to-high cable crossover": "https://youtu.be/1LhGmhVFe2Y?si=iPfhWoIZFYFAFa8H",
  "lying leg curl": "https://youtu.be/sX4tGtcc62k?si=5XUrPy7hXeIwCEvh",
  "lying paused rope face pull": "https://youtu.be/jTmI3Q1iQUk?si=o1TO-MoemioTKKDj",
  "machine chest-supported row + kelso shrug": "https://youtu.be/SUAafTp7WTQ?si=IPonYxxfswNOAXKM",
  "machine crunch": "https://youtu.be/K2yKEoazT3g?si=LNYL2xG_ijkSJ3f4",
  "machine hip abduction": "https://youtu.be/Jq4YWyLSh_o?si=43_rV0qMqZDO99c8",
  "machine hip adduction": "https://youtu.be/FMSCZYu1JhE?si=qf0xxDfSOpmwI4Rm",
  "machine lat pullover": "https://youtu.be/YT0K0PBl3nk?si=eOyyxU3FJq5FSw4f",
  "machine lateral raise": "https://youtu.be/5hZCR8lTdBk?si=ZMy6P01NVRyT3CCF",
  "machine pulldown": "https://youtu.be/kd6rshRa164?si=pnH3nJp8yyyMnZKE",
  "machine shoulder press": "https://youtu.be/SCQVmN1gYsk?si=260eJ_EGUnc7kzgh",
  "machine shrug": "https://youtu.be/ua0XuKwKQ9M?si=zUzhvYbaWJ3Iuekv",
  "machine squat": "https://youtu.be/whJzh_27yHs?si=SdztfNNzRqj1gnF9",
  "medicine ball russian twists": "https://youtu.be/eJF2gdt9PcE?si=tDKbeS7QVH5_4LEC",
  "medium-grip pull up": "https://youtu.be/5h_NehuTqe4?si=bZWK6q3A9wnD8TIW",
  "n1-style short-head curl": "https://youtu.be/qpzwJd7mr3Y?si=W6H5DYe7ShuBgEpM",
  "neutral-grip lat pulldown": "https://youtu.be/eiFpSJiyHnA?si=7SOYQSA6KX7-mX4Y",
  "neutral-grip pull-up": "https://youtu.be/b0ypSz63UGo?si=ls5OZ-Fx62x_ls0Q",
  "neutral-grip pullup": "https://youtu.be/b0ypSz63UGo?si=dMxuJGtxkR4jnUbb",
  "nordic ham curl": "https://youtu.be/fzpYiRtzmFA?si=sXXr1PAhYKYBiZ0G",
  "overhand lat pulldown": "https://youtu.be/IAktPXPhWYQ?si=GIbmS-vIl77yjMvg",
  "overhand machine row": "https://youtu.be/WtokJfvWl-I?si=mtvBsZgakHTbhP4c",
  "overhead cable curl": "https://youtu.be/0ZjD1gM8ldQ?si=KkvfpnuBkDqBUhTl",
  "overhead cable triceps extension (bar)": "https://youtu.be/9_I1PqZAjdA?si=_8o-jvYgFFzznrXT",
  "overhead cable triceps extension (rope)": "https://youtu.be/GYoUoVNlbGc?si=kR_6chPaKYj37j1U",
  "paused assisted dip": "https://youtu.be/RyGOGviYWts?si=Be01CpoR-9IG-Ds4",
  "paused barbell rdl": "https://youtu.be/74uXdbCYZQY?si=SzjStDAOXQdm3Zzp",
  "paused db rdl": "https://youtu.be/gzavDZmYDHk?si=W8Lo-seZcaDZrnyC",
  "pec deck": "https://youtu.be/CI88L1VNvEs?si=UjPZ3Ep5QaYBM5rC",
  "pec deck (w/ integrated partials)": "https://youtu.be/NPa8YvUg4CM?si=jtlF4pmK0Siy1W7z",
  "plate-loaded neck curls": "https://youtu.be/CuIkTLjx6fo?si=7TgkZEKuBQNEuaKz",
  "plate-loaded neck extension": "https://youtu.be/av_h904QAEY?si=8RUYGEr7Fg0cz1TS",
  "plate-weighted crunch": "https://youtu.be/mP99WSRI6Bc?si=RKs1Lov38A6ZekUd",
  "prisoner 45\u00b0 hyperextension": "https://youtu.be/jshWFhUTE-o?si=Dwd17TWYrIlK-R50",
  "pull-up": "https://youtu.be/5h_NehuTqe4?si=bZWK6q3A9wnD8TIW",
  "rear delt 45\u00b0 cable flye": "https://youtu.be/8iXorduqXC8?si=xrV6KJQVunIM26oW",
  "reverse cable flye": "https://youtu.be/zX_uPN0szeU?si=JfL23VTnm7ik_mKN",
  "reverse cable flye (w/ integrated partials)": "https://youtu.be/QkAMC88WfXw?si=UB30tLiuG2mgu8Tm",
  "reverse crunch": "https://youtu.be/fYZmIC9_sx4?si=YTyAq0ErOoGaAfYY",
  "reverse nordic": "https://youtu.be/D-kqUKEQZZ0?si=3tbb6I_kCXyuWMz8",
  "reverse nordics": "https://youtu.be/D-kqUKEQZZ0?si=VtvQB1fXGOUyt007",
  "reverse pec deck": "https://youtu.be/Y8fb_rtEU_4?si=cG3hOxAoChRUlL8x",
  "reverse pec deck (w/ integrated partials)": "https://youtu.be/KDeYqB9GYeg?si=wIoeBXTOU2LZ1XMQ",
  "reverse-grip cable curl": "https://youtu.be/xtZvYrfw2Is?si=FvJmRz10c7mwsjMI",
  "reverse-grip db curl": "https://youtu.be/KYfVrzmh-GU?si=bzqo7aXMS21mySzo",
  "reverse-grip ez-bar curl": "https://youtu.be/IZNaQzWXgwA?si=E8C8kydySwFmM2-F",
  "roman chair leg raise": "https://youtu.be/irOzFVqJ0IE?si=bu_fLYx4BOeKpE1X",
  "rope face pull": "https://youtu.be/GhrVM-jPIEA?si=f8Ebrsq1a3ee0yfc",
  "seated barbell shoulder press": "https://youtu.be/rRpQJAJZgiI?si=j6DGJkw86y7am4ht",
  "seated calf raise": "https://youtu.be/6pfj0G7VKdM?si=bXJmuLkyC3E3PYHW",
  "seated db french press": "https://youtu.be/5KX0EjOTMaI?si=3G7-aNuHyHvJEK2G",
  "seated db shoulder press": "https://youtu.be/B8PB5RPhTWQ?si=XNDiefvHddNOk_wI",
  "seated leg curl": "https://youtu.be/yv0aAY7M1mk?si=j3yJRloK4DtagbP5",
  "side-to-side leg swings": "https://youtu.be/tFpwBr_7KPg?si=0T63q37dQLKi118I&t=28",
  "single-arm overhead cable triceps extension": "https://youtu.be/eNHOA90QcAg?si=ByNaCK9v0w3UV6nJ",
  "single-leg db hip thrust": "https://youtu.be/V8uasBf-Es8?si=gQnazxPhJYq_AQuY",
  "single-leg leg press": "https://youtu.be/zURHw38OZTM?si=YjlJmvRnK4RdR82u",
  "sissy squat": "https://youtu.be/eWAjlO4FWPQ?si=Nfo6m5QeXeyFv15y",
  "sissy squats": "https://youtu.be/eWAjlO4FWPQ?si=Sp6bNaQILVR8lBo6",
  "slow-eccentric barbell rdl": "https://youtu.be/PeXi-Yvn6kI?si=xCCbw2NKXLbxMcyR",
  "slow-eccentric bayesian curl": "https://youtu.be/Kf2kXBoIgM0?si=7djq654yF0WyvOTz",
  "slow-eccentric db curl": "https://youtu.be/49VVIiqqOOs?si=RyUV-l6iqk2xj1T2",
  "slow-eccentric db french press": "https://youtu.be/EAW6XDAlZPo?si=8JS596u04g_aAJj6",
  "slow-eccentric db incline curl": "https://youtu.be/_ceLw3Q6uTA?si=6Y8XYLK3TObVCuxm",
  "slow-eccentric db rdl": "https://youtu.be/9XIvGzgvoE0?si=Z6JqAw9oC1LYwS8G",
  "slow-eccentric db scott curl": "https://youtu.be/ijgSR2yriyg?si=OPa2ojil3TSfRlU5",
  "slow-eccentric db skull crusher": "https://youtu.be/HpW1nqPsGvw?si=Syt_OdzLhS-KyrP-",
  "slow-eccentric ez-bar skull crusher": "https://youtu.be/opVMIWzaNFY?si=Km9JF0KncL5Dp22e",
  "slow-eccentric glute-ham raise": "https://youtu.be/glfk5LBDQf0?si=6fxdFZukgjQDDiMb",
  "smith machine jm press": "https://youtu.be/zv5bwzjN1Q4?si=tR-RcmuAxI2NE_Dm",
  "smith machine lunge": "https://youtu.be/SEjKxJGg_C8?si=UlSI6XBXlGJ825UM",
  "smith machine reverse lunge": "https://youtu.be/D0KZo_gBsw0?si=-l8uDis1gT8Xb34S",
  "smith machine shoulder press": "https://youtu.be/Ru2yE4wWUvE?si=fCjEz5M7EVLDnyAf",
  "smith machine squat": "https://youtu.be/lWIEZ6NxPMk?si=3b8WGrsGFNx-FZxi",
  "snatch-grip rdl": "https://youtu.be/CenC1xVpMvI?si=Xb9_PvyzfhaUluxV",
  "spider curl": "https://youtu.be/jw9tvoGLJmo?si=ympzQYhl7OHkWl2i",
  "standing calf raise": "https://youtu.be/6lR2JdxUh7w?si=iqhaqemZrelhtW_J",
  "standing db arnold press": "https://youtu.be/xBJBTfPcvhM?si=NFE_AU6W1NDpM7oX",
  "stomach vacuums": "https://youtu.be/dyFeDqVApFU?si=G67U_1AH_XAqpNGH",
  "straight-bar lat prayer": "https://youtu.be/YrcnBlH8XDA?si=-Us_1Pr1zyUZ1BmI",
  "super-rom db lateral raise": "https://youtu.be/nW5pGot-Hok?si=42t_Ve0IbNNy-Erx",
  "super-rom overhand cable row": "https://youtu.be/a7AH8W7dQIw?si=d2sg2JoiuHk5_Cc7",
  "superset a1: assisted pull-up": "https://youtu.be/iZQNHZuvfUQ?si=HbK5zxsfGHiDqYPT",
  "superset a2: paused assisted dip": "https://youtu.be/RyGOGviYWts?si=I8nT4hN37uUDkW5M",
  "superset b1: seated leg curl": "https://youtu.be/yv0aAY7M1mk?si=gWlSMWsY7YXnjE7c",
  "superset b2: leg extension": "https://youtu.be/uFbNtqP966A?si=AMbutqVPt7YGZ6OP",
  "swiss ball rollout": "https://youtu.be/FvekMyIs-yk?si=WdIq5_FWC4EicNKZ",
  "triceps diverging pressdown (long rope or 2 ropes)": "https://youtu.be/20tbMlP71Nc?si=nriTCkpWbcxIcOjq",
  "triceps pressdown (bar)": "https://youtu.be/o4eazahiXQw?si=4c3FyBfWpTYy5lwN",
  "triceps pressdown (rope)": "https://youtu.be/bCa036rGtVU?si=-nO7P-Ep1mPG5OXW",
  "wide-grip band-assisted pull-up": "https://youtu.be/6LGHiZ5iZbE?si=kRtkyA62iBOH0zzk",
  "wide-grip lat pulldown": "https://youtu.be/IYXRrYXfVLc?si=qzklwz0DBbgbbu75",
};
